import React, {useState, useEffect} from "react";
import {a134, a135, a139, a189, a190, a239, a240} from "../../Api/RootApiPath";
import {useSelector} from "react-redux";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
import "../PagesStyles/AdminSettings.css";
import {RiListUnordered, RiPlayListAddLine} from "react-icons/ri";
import moment from "moment";
import {Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField} from "@mui/material";
import AlertMessage from "../../Other Functions/AlertMessage";
import style from "./AddRatesNew.module.css"
import { useRef } from "react";
import { Icon } from "@iconify/react";
import Customertable from "Components/support/customervendor/customer";

export default function 
AddRatesNew() {
    const [inputValues, setInputValues] = useState({});
    const [active, setActive] = useState("AddNew");
    const [purityData, setPurityData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const [messageType, setMessageType] = useState("");
    const [messageToShow, setMessageToShow] = useState("");
    const allStates = useSelector((state) => state);
    const adminLoggedIn = allStates.reducer1;
    const clientCode = adminLoggedIn.ClientCode;
      const [searchInput, setSearchInput] = useState('');



      const handleSearchChange = (event) => {
        setSearchInput(event.target.value);
      };

      
    
      
    
      const handleSearchSubmit = () => {
        // You can handle the search logic here
        console.log("Searching for:", searchTerm);
      };

    useEffect(() => {
        fetchAllPurity();
    }, []);
    useEffect(() => {
        setTimeout(() => {
            setShowError(false);
        }, 2000);
    }, [showError]);
    const fetchAllPurity = async () => {
        const formData = {ClientCode: clientCode};
        await fetch(a134, {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(formData),
        })
            .then((res) => res.json())
            .then((data) => setPurityData(data));
    };

    useEffect(() => {
        console.log('purityData', purityData);
        
    },[purityData])

    const handleSubmit = async (e) => {
        e.preventDefault();


        const ratesWithTodayRate = purityData.map(item => {
            return {
                CategoryId : item.CategoryId,
                // EmployeeCode : item.EmployeeCode,
                EmployeeCode : item.ClientCode,
                Rate: inputValues[item.Id] || item.TodaysRate,
                PurityId: purityData.find((item2) => item2.PurityName === item.PurityName).Id,
                ClientCode : item.ClientCode
            }
        });

        try {
            const response = await fetch(a240, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(ratesWithTodayRate),
            });
            const data = await response.json();
            if (data.Message) {
                setMessageType("error");
                setMessageToShow(data.Message);
                setShowError(true);
            } else {
                setMessageType("success");
                setMessageToShow("Rate Updated Successfully");
                setActive("List")
                fetchAllPurity();
                setShowError(true)
            }
        } catch (error) {
            setMessageType("error");
            setMessageToShow(error);
            setShowError(true);
        }
        console.log("Items with today's rates:", ratesWithTodayRate);
    }

    const columns = [
        { key: "serialNumber", label: "S.No", type: "read", priority: 2 },
        { key: "CreatedOn", label: "Date", type: "read", priority: 1 },
    
        { key: "CategoryName", label: "Category", type: "read", priority: 3 },
        { key: "PurityName", label: "Purity", type: "read", priority: 4 },
        { key: "FinePercentage", label: "Fine Percentage", type: "read", priority: 5 },
        { key: "TodaysRate", label: "Todays Rate", type: "read", priority: 6 },
    
     
      ];


      const handleResetField = () => {
        // List of all input and select refs
        const allRefs = [
          inputRef1,
          inputRef2,
          inputRef3,
          inputRef4,
          inputRef5,
          inputRef6,
          inputRef7,
          inputRef8,
          inputRef9,
          inputRef10,
          inputRef11,
          inputRef12,
          inputRef13,
          inputRef14,
          inputRef15,
          inputRef16,
          inputRef17,
          inputRef18,
          inputRef19,
          
      ];
  
  
  
    
       
    
        // Loop through each ref and reset the value
        allRefs.forEach((ref) => {
          if (ref.current) {
            if (ref.current.tagName === "SELECT") {
              ref.current.selectedIndex = 0; // Reset <select> to the first option
            } else {
              ref.current.value = ""; // Clear input field
            }
          }
        });
    
        // Refocus on the first input after reset
        inputRef1.current?.focus();
      };

      const handleList = () => {
        // Custom logic for the List button
        console.log("List button clicked");
        setActive("List");
      };

    return (
        <div>
            <AdminHeading/>
            <div className="adminMainBodyBox">
                {showError ? (
                    <AlertMessage message={messageToShow} type={messageType}/>
                ) : null}
                <AdminBreadCrump
                    title={"Add Daily Rates"}
                    companyName={"Loyalstring"}
                    module={"Settings"}
                    page={"Daily Rates"}
                />
                </div>



                


    <div style={{ padding: "16px" }}>
            {
                active === "List" ? (
                    <>
                    <div className={style["white-space"]}>
                     
                      <div className={style["icon-div"]}>
                        <div className={style["search-container"]}>
                          <input
                            type="text"
                            value={searchInput}
                            onChange={handleSearchChange}
                            placeholder="Search..."
                            className={style["serach-input"]}
                          />
                          <button
                            style={{ margin: 0 }}
                            className={style["search-btn"]}
                            onClick={handleSearchSubmit}
                          >
                            <Icon style={{ fontSize: "20px" }} icon="mdi:magnify" />
                          </button>
                        </div>
                        <Icon
                          style={{
                            fontSize: "28px ",
                            color: "#0077d4",
                            cursor: "pointer",
                          }}
                          icon="bx:export"
                        />
                        <button
                          style={{ width: "30%" }}
                          className={style["custom-btn"]}
                        >
                          <Icon style={{ fontSize: "24px " }} icon="ic:outline-print" />
                          Print
                        </button>
                      </div>
                    </div>
        
                    <Customertable
                      columns={columns}
                      allCategories={purityData}
                    //   handleEditData={handleEditData}
                      searchInput={searchInput}
                      setSearchInput={setSearchInput}
                     
                      // title={"All Customers"}
                    />
        
                    
                  </>
                ): (
                    <div className={style.adminAddCategoryMainBox}>
            <div className={style.adminAddCategoryInnerBox}>
              <div className={style.adminCategoryAddCategoryMainBox}>
              <p>Add Rate</p>
                            <form onSubmit={handleSubmit}>
                                <div>
                                    <TableContainer sx={{' th, td': {border: '1px solid #ccc'}}}>
                                        <Table sx={{
                                            " td": {padding: "4px"},
                                            " th": {padding: "10px"},
                                            " td > div": {width: "50%"}
                                        }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{fontWeight: '600'}}>Category</TableCell>
                                                    <TableCell sx={{fontWeight: '600'}}>Purity</TableCell>
                                                    <TableCell sx={{fontWeight: '600'}}>Fine Percentage</TableCell>
                                                    <TableCell sx={{fontWeight: '600'}}>Todays Rate</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {purityData.map((x) => (
                                                    <TableRow key={x.Id}>
                                                        <TableCell>{x.CategoryName}</TableCell>
                                                        <TableCell>{x.PurityName}</TableCell>
                                                        <TableCell>{x.FinePercentage}</TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                type="text"
                                                                value={inputValues[x.Id] || ''}
                                                                placeholder={x.TodaysRate.toString()}
                                                                onChange={(e) =>
                                                                    setInputValues({
                                                                        ...inputValues,
                                                                        [x.Id]: e.target.value,
                                                                    })
                                                                }
                                                                sx={{width: '80px', marginRight: '10px'}}
                                                                size="small"
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                                <Box sx={{textAlign: "right"}}>
                                    {!loading ? 
                                     <div style={{marginTop:'15px'}} className={style["btn-container"]}>
                                     <button className={style.buttons} type="submit">
                                       <Icon
                                         icon="ic:baseline-check"
                                         width="24"
                                         height="24"
                                       />{" "}
                                       Submit
                                     </button>
                                     <button
                                     
                                       className={style.buttons}
                                       style={{
                                         backgroundColor: "#fff",
                                         color: "#0077d4",
                                         border: "1px solid #0077d4",
                                       }}
                                       type="button"
                                       onClick={handleResetField}
                                     >
                                       <Icon
                                         style={{ color: "#0077d4" }}
                                         icon="ix:reset"
                                         width="24"
                                         height="24"
                                       />
                                       Reset
                                     </button>
                                     <button
                                       className={style.buttons}
                                       type="button"
                                       onClick={handleList}
                                     >
                                       <Icon
                                         icon="fluent:list-rtl-16-filled"
                                         width="24"
                                         height="24"
                                       />
                                       List
                                     </button>
                                   </div>
                                    : null}
                                </Box>
                            </form>
              </div>
              </div>
              </div>
                )
            }
        </div>
        </div>
    );
}
